<!--
Logout screen
@author bmk11u
-->
<template>
  <div>
    <div id="loginLogo">
      <img class="loginLogoImg" src="@/assets/UofG_App_Logo.svg" alt="University of Glasgow Logo" height="110px"/>
    </div>
    <Spinner ref="spinner" />
  </div>
</template>

<script>
// import $cookies from 'vue-cookies'
import axios from 'axios'
import IDBCommon from '@/mixins/IDBCommon.js'
import * as lst from '@/components/localStorage.js'

export default {
  name: 'Logout',
  components: {
  },
  // mixins: [IDBCommon],
  data () {
    return {
      hybrid: process.env.VUE_APP_MODE === 'hybrid'
    }
  },
  mixins: [IDBCommon],
  mounted () {
    // BYPASS THIS SCREEN
    this.$refs.spinner.spin()
    // const guid = this.$cookies.get('guid')
    // End server session then delete cookies on client
    axios.delete('/timetable/login')
      .then(() => {
        this.$refs.spinner.stop()
        /* $cookies.keys().forEach(cookie => {
          $cookies.remove(cookie)
        }) */
        // remove idb data for user if any
        const guid = lst.getUserGuid()
        if (typeof guid !== 'undefined' && guid !== null) {
          console.log('removing stored data for ' + guid)
          this.deleteFor(guid)
        }
        lst.clearAll()
        this.$router.push('login')
      })
      .catch(() => {
        this.$router.push('index')
      })
  }
}
</script>
<style scoped>
#loginLogo {
  height:200px;
  background-color:#003865;
  text-align:center;
}
</style>
